/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { type Meta, type StoryObj } from '@storybook/react-vite';

import { Typography } from '../Typography';
import {
  TypographyAnchor,
  TypographyAnchorSource,
  TypographyDefault,
  TypographyDefaultSource,
  TypographyVariants,
  TypographyVariantsSource,
} from '.';

const componentMeta: Meta<typeof Typography> = {
  component: Typography,
  id: 'components-typography',
  parameters: {
    controls: { disable: true },
  },
  tags: ['docsPage'],
  title: 'Components/Typography',
};

export default componentMeta;
type Story = StoryObj<typeof Typography>;

export const Default: Story = {
  parameters: {
    docs: {
      source: {
        code: TypographyDefaultSource,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: TypographyDefault,
};

export const Anchor: Story = {
  parameters: {
    docs: {
      source: {
        code: TypographyAnchorSource,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: TypographyAnchor,
};

export const Variants: Story = {
  parameters: {
    docs: {
      source: {
        code: TypographyVariantsSource,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: TypographyVariants,
};
